const initializeGiftGuide = () => {
  document.querySelectorAll('#MainContent[data-template="page.gift-guide"] .category-collection').forEach((section) => {


    // 变体选择器交?
    const productCards = section.querySelectorAll('.main-product-card-content[data-product]');

    productCards.forEach((card) => {
      const colorBars = card.querySelectorAll('.color-bar');
      const productImage = card.querySelector('.product-image img');

      if (productImage) {
        const originalImage = productImage.src;

        colorBars.forEach((bar) => {
          bar.addEventListener('click', function (e) {
            e.preventDefault();

            // 移除其他颜色的active状�?
            colorBars.forEach((b) => { b.classList.remove('active'); b.setAttribute('aria-pressed', 'false'); });
            // 添加当前颜色的active状�?
            this.classList.add('active');
            this.setAttribute('aria-pressed', 'true');

            const variantImage = this.getAttribute('data-img');
            if (variantImage && variantImage !== 'null') {
              const variantName = this.getAttribute('data-name');
              const variantNameDom = card.querySelector('.variant-name');
              if (variantNameDom) variantNameDom.textContent = variantName;
              productImage.removeAttribute('srcset');
              productImage.src = variantImage;
            } else {
              productImage.src = originalImage;
            }

            const price = card.querySelector('.product-price');
            if (price) {
              price.replaceChildren();
              const current = document.createElement('span');
              current.textContent = this.dataset.price;
              price.append(current);
              if (this.dataset.compare) {
                const previous = document.createElement('s');
                previous.textContent = this.dataset.compare;
                price.append(' ', previous);
              }
            }
            const submit = card.querySelector('button[name="add"]');
            if (submit) {
              submit.disabled = this.dataset.available !== 'true';
              submit.querySelector('.add-to-cart-text__custom').textContent = submit.disabled ? section.dataset.soldOutLabel : section.dataset.cartLabel;
            }
            const selectedVariantId = this.getAttribute('data-var');
            if (selectedVariantId) {
              const idInputs = card.querySelectorAll('form [name="id"]');
              idInputs.forEach((input) => {
                input.value = selectedVariantId;
              });
            }
          });
        });
      }
    });

  });
};
if (document.readyState !== 'complete') document.addEventListener('DOMContentLoaded', initializeGiftGuide, { once: true });
else initializeGiftGuide();

